import { useState } from 'react';
import { Tooltip, StandardTooltipWindow } from './Tooltip';

const DropDownLabel = (props) => {
    const { toggleOpen, classStr = 'drop', selected } = props;
    return (
        <div className={`${classStr}-hold value-hold icon-${selected.icon}`} onClick={toggleOpen}>
            <div className="icon-selectarrow">{selected.label}</div>
        </div>
    );
};

const DropCheck = (props) => {
    const { onChange, classStr = 'drop', label, tooltip, list, placeholder, tooltipPlace } = props;
    const [open, setOpen] = useState(false);
    const toggleOpen = () => {
        setOpen(true);
    };

    const onSelectItem = (e) => {
        const val = !e.target.getAttribute('value');
        const name = e.target.getAttribute('name');
        onChange(name, val);
    };
    const onKeyDown = (e) => {
        if (e.code == 'Space') {
            onSelectItem(e);
            e.preventDefault();
        }
    };
    return (
        <div
            className={`${classStr} dropdown check ${open ? ' open' : ' closed'}`}
            tabIndex={0}
            onMouseLeave={() => {
                setOpen(false);
            }}
            onFocus={() => setOpen(true)}
            onBlur={() => setOpen(false)}
        >
            <Tooltip id={label} tooltip={tooltip} window={<StandardTooltipWindow id={label} text={tooltip} tooltipPlace={tooltipPlace} />}>
                <div className="hit-area" onClick={toggleOpen}>
                    <label>{label}</label>
                    <DropDownLabel selected={{ label: placeholder, icon: '' }} toggleOpen={toggleOpen} />
                    <div className={'contain' + (open ? ' open' : ' closed')}>
                        <div className={'wrap ' + (open ? 'open' : 'closed')} onMouseLeave={toggleOpen}>
                            <div className="arrow"></div>
                            <div className={`${classStr}-control`} size={list.length}>
                                {list.map((t, i) => {
                                    return (
                                        <div key={i} name={t.slug} tabIndex={0} className={`${classStr}-item dropdown-item icon-${t.selected ? 'square-checked' : 'square'}`} onKeyDown={onKeyDown} onClick={onSelectItem} value={t.selected} role="checkbox">
                                            <span name={t.slug} className={` icon-${t.icon}`}>
                                                {t.label}
                                            </span>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </Tooltip>
        </div>
    );
};

export default DropCheck;
